import React, {ReactNode} from "react";
import MenuItem from "@mui/material/MenuItem";
import {Text} from "./Text";
import {SxProps} from "@mui/system";
import {Container} from "./Container";

export interface IconMenuItemProps {
  label: string;
  value?: string;
  icon?: ReactNode;
  endIcon?: ReactNode;
  noneCapitalize?: boolean;
  disabled?: boolean;
  divider?: boolean;
  onClick?: () => void;
  fontWeight?: number | "medium";
  color?: string;
  sx?: SxProps;
}

const IconMenuItem = ({
  label,
  value,
  icon,
  endIcon,
  noneCapitalize = true,
  disabled,
  onClick,
  divider = true,
  fontWeight = 500,
  color,
  sx,
}: IconMenuItemProps) => {
  return (
    <MenuItem
      disableRipple
      onClick={onClick}
      value={value}
      disabled={disabled}
      divider={divider}
      sx={{width: "100%", ...sx}}
    >
      <Container row sx={{alignItems: "center", width: "100%", justifyContent: "space-between"}}>
        <Container row sx={{alignItems: "center"}}>
          {icon}
          <Text
            fontWeight={fontWeight}
            color={color}
            size={14}
            sx={{...(!noneCapitalize && {textTransform: "capitalize"})}}
          >
            {label}
          </Text>
        </Container>
        {endIcon}
      </Container>
    </MenuItem>
  );
};
export default IconMenuItem;
